import type { Brand, BrandAssets } from '~/brand/type'
import { getLocalBrandAssets } from '~/brand/assets'

function useBuildTimeBrand() {
  // приводим к Brand явно: Nuxt выводит тип public.brandConfig из значения,
  // активного в момент `nuxi prepare`, а не из объявленного интерфейса
  return useRuntimeConfig().public.brandConfig as Brand
}

export function useBrandAssets() {
  return useState<BrandAssets>('brandAssets', () => getLocalBrandAssets(useBuildTimeBrand()))
}

export function useBrand() {
  const brand = useBuildTimeBrand()
  const brandAssets = useBrandAssets()
  const { branding } = storeToRefs(useFeatureStore())
  const colorMode = useColorMode()
  const isDark = computed(() => colorMode.value === 'dark')

  const brandName = computed(() => branding.value?.brand_name || brand.name)
  const pageTitle = computed(
    () => branding.value?.page_title || `Trading Platform | ${brandName.value}`
  )

  const logoDark = computed(
    () => branding.value?.themes?.dark?.logo_url || brandAssets.value.logo.dark
  )
  const logoLight = computed(
    () => branding.value?.themes?.light?.logo_url || brandAssets.value.logo.light
  )
  const logoSmDark = computed(
    () => branding.value?.themes?.dark?.logo_compact_url || brandAssets.value.logoSm.dark
  )
  const logoSmLight = computed(
    () => branding.value?.themes?.light?.logo_compact_url || brandAssets.value.logoSm.light
  )
  const favicon = computed(() => branding.value?.favicon_url || brandAssets.value.favicon)
  const logo = computed(() => (isDark.value ? logoDark.value : logoLight.value))
  const logoSm = computed(() => (isDark.value ? logoSmDark.value : logoSmLight.value))

  return {
    brand: computed(() => ({ ...brand, name: brandName.value })),
    pageTitle,
    favicon,
    logoSm,
    logoDark,
    logoLight,
    logo
  }
}
